namespace Matrix.Workflow {
    export interface TaskForm {
        WorkflowCode: Serenity.LookupEditor;
        TaskCode: Serenity.StringEditor;
        SequenceNumber: Serenity.IntegerEditor;
        Description: Serenity.StringEditor;
        ReadPermissions: Serenity.StringEditor;
        WritePermissions: Serenity.StringEditor;
        Properties: Serenity.TextAreaEditor;
        Class1Name: Serenity.StringEditor;
        Class1: Serenity.StringEditor;
        Class2Name: Serenity.StringEditor;
        Class2: Serenity.StringEditor;
        Class3Name: Serenity.StringEditor;
        Class3: Serenity.StringEditor;
        Class4Name: Serenity.StringEditor;
        Class4: Serenity.StringEditor;
        Class5Name: Serenity.StringEditor;
        Class5: Serenity.StringEditor;
        Key1Name: Serenity.StringEditor;
        Key1: Serenity.StringEditor;
        Key2Name: Serenity.StringEditor;
        Key2: Serenity.StringEditor;
        Key3Name: Serenity.StringEditor;
        Key3: Serenity.StringEditor;
        Key4Name: Serenity.StringEditor;
        Key4: Serenity.StringEditor;
        Key5Name: Serenity.StringEditor;
        Key5: Serenity.StringEditor;
        C1Name: Serenity.StringEditor;
        C1: Serenity.StringEditor;
        C2Name: Serenity.StringEditor;
        C2: Serenity.StringEditor;
        C3Name: Serenity.StringEditor;
        C3: Serenity.StringEditor;
        C4Name: Serenity.StringEditor;
        C4: Serenity.StringEditor;
        C5Name: Serenity.StringEditor;
        C5: Serenity.StringEditor;
        C6Name: Serenity.StringEditor;
        C6: Serenity.StringEditor;
        C7Name: Serenity.StringEditor;
        C7: Serenity.StringEditor;
        C8Name: Serenity.StringEditor;
        C8: Serenity.StringEditor;
        C9Name: Serenity.StringEditor;
        C9: Serenity.StringEditor;
        C10Name: Serenity.StringEditor;
        C10: Serenity.StringEditor;
        B1Name: Serenity.StringEditor;
        B1: Serenity.BooleanEditor;
        B2Name: Serenity.StringEditor;
        B2: Serenity.BooleanEditor;
        B3Name: Serenity.StringEditor;
        B3: Serenity.BooleanEditor;
        B4Name: Serenity.StringEditor;
        B4: Serenity.BooleanEditor;
        B5Name: Serenity.StringEditor;
        B5: Serenity.BooleanEditor;
        B6Name: Serenity.StringEditor;
        B6: Serenity.BooleanEditor;
        B7Name: Serenity.StringEditor;
        B7: Serenity.BooleanEditor;
        B8Name: Serenity.StringEditor;
        B8: Serenity.BooleanEditor;
        B9Name: Serenity.StringEditor;
        B9: Serenity.BooleanEditor;
        B10Name: Serenity.StringEditor;
        B10: Serenity.BooleanEditor;
        N1Name: Serenity.StringEditor;
        N1: Serenity.IntegerEditor;
        N2Name: Serenity.StringEditor;
        N2: Serenity.IntegerEditor;
        N3Name: Serenity.StringEditor;
        N3: Serenity.IntegerEditor;
        N4Name: Serenity.StringEditor;
        N4: Serenity.IntegerEditor;
        N5Name: Serenity.StringEditor;
        N5: Serenity.IntegerEditor;
        N6Name: Serenity.StringEditor;
        N6: Serenity.IntegerEditor;
        N7Name: Serenity.StringEditor;
        N7: Serenity.IntegerEditor;
        N8Name: Serenity.StringEditor;
        N8: Serenity.IntegerEditor;
        N9Name: Serenity.StringEditor;
        N9: Serenity.IntegerEditor;
        N10Name: Serenity.StringEditor;
        N10: Serenity.IntegerEditor;
        F1Name: Serenity.StringEditor;
        F1: Serenity.DecimalEditor;
        F2Name: Serenity.StringEditor;
        F2: Serenity.DecimalEditor;
        F3Name: Serenity.StringEditor;
        F3: Serenity.DecimalEditor;
        F4Name: Serenity.StringEditor;
        F4: Serenity.DecimalEditor;
        F5Name: Serenity.StringEditor;
        F5: Serenity.DecimalEditor;
        F6Name: Serenity.StringEditor;
        F6: Serenity.DecimalEditor;
        F7Name: Serenity.StringEditor;
        F7: Serenity.DecimalEditor;
        F8Name: Serenity.StringEditor;
        F8: Serenity.DecimalEditor;
        F9Name: Serenity.StringEditor;
        F9: Serenity.DecimalEditor;
        F10Name: Serenity.StringEditor;
        F10: Serenity.DecimalEditor;
        D1Name: Serenity.StringEditor;
        D1: Serenity.DateTimeEditor;
        D2Name: Serenity.StringEditor;
        D2: Serenity.DateTimeEditor;
        D3Name: Serenity.StringEditor;
        D3: Serenity.DateTimeEditor;
        D4Name: Serenity.StringEditor;
        D4: Serenity.DateTimeEditor;
        D5Name: Serenity.StringEditor;
        D5: Serenity.DateTimeEditor;
        Txt1Name: Serenity.StringEditor;
        Txt1: Serenity.TextAreaEditor;
        Txt2Name: Serenity.StringEditor;
        Txt2: Serenity.TextAreaEditor;
        Txt3Name: Serenity.StringEditor;
        Txt3: Serenity.TextAreaEditor;
        Txt4Name: Serenity.StringEditor;
        Txt4: Serenity.TextAreaEditor;
        Txt5Name: Serenity.StringEditor;
        Txt5: Serenity.TextAreaEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class TaskForm extends Serenity.PrefixedContext {
        static formKey = 'Workflow.Task';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TaskForm.init)  {
                TaskForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.TextAreaEditor;
                var w4 = s.BooleanEditor;
                var w5 = s.DecimalEditor;
                var w6 = s.DateTimeEditor;
                var w7 = StaticTextBlock;
                var w8 = ReadOnlyDateTime;

                Q.initFormType(TaskForm, [
                    'WorkflowCode', w0,
                    'TaskCode', w1,
                    'SequenceNumber', w2,
                    'Description', w1,
                    'ReadPermissions', w1,
                    'WritePermissions', w1,
                    'Properties', w3,
                    'Class1Name', w1,
                    'Class1', w1,
                    'Class2Name', w1,
                    'Class2', w1,
                    'Class3Name', w1,
                    'Class3', w1,
                    'Class4Name', w1,
                    'Class4', w1,
                    'Class5Name', w1,
                    'Class5', w1,
                    'Key1Name', w1,
                    'Key1', w1,
                    'Key2Name', w1,
                    'Key2', w1,
                    'Key3Name', w1,
                    'Key3', w1,
                    'Key4Name', w1,
                    'Key4', w1,
                    'Key5Name', w1,
                    'Key5', w1,
                    'C1Name', w1,
                    'C1', w1,
                    'C2Name', w1,
                    'C2', w1,
                    'C3Name', w1,
                    'C3', w1,
                    'C4Name', w1,
                    'C4', w1,
                    'C5Name', w1,
                    'C5', w1,
                    'C6Name', w1,
                    'C6', w1,
                    'C7Name', w1,
                    'C7', w1,
                    'C8Name', w1,
                    'C8', w1,
                    'C9Name', w1,
                    'C9', w1,
                    'C10Name', w1,
                    'C10', w1,
                    'B1Name', w1,
                    'B1', w4,
                    'B2Name', w1,
                    'B2', w4,
                    'B3Name', w1,
                    'B3', w4,
                    'B4Name', w1,
                    'B4', w4,
                    'B5Name', w1,
                    'B5', w4,
                    'B6Name', w1,
                    'B6', w4,
                    'B7Name', w1,
                    'B7', w4,
                    'B8Name', w1,
                    'B8', w4,
                    'B9Name', w1,
                    'B9', w4,
                    'B10Name', w1,
                    'B10', w4,
                    'N1Name', w1,
                    'N1', w2,
                    'N2Name', w1,
                    'N2', w2,
                    'N3Name', w1,
                    'N3', w2,
                    'N4Name', w1,
                    'N4', w2,
                    'N5Name', w1,
                    'N5', w2,
                    'N6Name', w1,
                    'N6', w2,
                    'N7Name', w1,
                    'N7', w2,
                    'N8Name', w1,
                    'N8', w2,
                    'N9Name', w1,
                    'N9', w2,
                    'N10Name', w1,
                    'N10', w2,
                    'F1Name', w1,
                    'F1', w5,
                    'F2Name', w1,
                    'F2', w5,
                    'F3Name', w1,
                    'F3', w5,
                    'F4Name', w1,
                    'F4', w5,
                    'F5Name', w1,
                    'F5', w5,
                    'F6Name', w1,
                    'F6', w5,
                    'F7Name', w1,
                    'F7', w5,
                    'F8Name', w1,
                    'F8', w5,
                    'F9Name', w1,
                    'F9', w5,
                    'F10Name', w1,
                    'F10', w5,
                    'D1Name', w1,
                    'D1', w6,
                    'D2Name', w1,
                    'D2', w6,
                    'D3Name', w1,
                    'D3', w6,
                    'D4Name', w1,
                    'D4', w6,
                    'D5Name', w1,
                    'D5', w6,
                    'Txt1Name', w1,
                    'Txt1', w3,
                    'Txt2Name', w1,
                    'Txt2', w3,
                    'Txt3Name', w1,
                    'Txt3', w3,
                    'Txt4Name', w1,
                    'Txt4', w3,
                    'Txt5Name', w1,
                    'Txt5', w3,
                    'CreatedBy', w7,
                    'CreatedWhen', w8,
                    'UpdatedBy', w7,
                    'UpdatedWhen', w8,
                    'Version', w7
                ]);
            }
        }
    }
}
